module.exports = __webpack_public_path__ + "img/sfks2-3.84602866.jpg";